module.exports = __webpack_public_path__ + "static/media/kevin-smith.6834d53f.png";